import React, { useCallback, useState } from 'react';
import { AspectRatio } from 'components/AspectRatioSelector';
import LinkButton from 'components/LinkButton';
import Wizard, { Step } from 'components/Wizard';
import { AspectRatioName } from 'types';
import { createChainedFunction } from 'utils/functions';
import AspectRatioStep from '../../AspectRatioStep';
import { VideoFlowStep } from './types';
import { block } from './utils';

export type UseAspectRatioStepProps = {
  aspectRatioName: AspectRatioName;
  onBackClick?: () => void;
  onSubmit?: (aspectRatioName: AspectRatioName) => void;
};

export default function useAspectRatioStep({
  aspectRatioName,
  onSubmit,
  onBackClick,
}: UseAspectRatioStepProps) {
  const [draftAspectRatioName, setDraftAspectRatioName] = useState(
    aspectRatioName,
  );

  const handleSelect = useCallback((_: AspectRatio, name: AspectRatioName) => {
    setDraftAspectRatioName(name);
  }, []);

  const handleNext = useCallback(() => {
    onSubmit?.(draftAspectRatioName);
  }, [onSubmit, draftAspectRatioName]);

  const step: Step<VideoFlowStep.ASPECT_RATIO> = {
    component: (
      <AspectRatioStep onSelect={handleSelect} value={draftAspectRatioName} />
    ),
    description: (
      <LinkButton
        uppercase
        theme="cta"
        size="md"
        className={block('back-link')}
        onClick={onBackClick}
      >
        ← return to all options
      </LinkButton>
    ),
    name: 'Aspect Ratio',
    renderNextButton: props => (
      <Wizard.Button
        {...props}
        onClick={createChainedFunction(props.onClick, handleNext)}
        theme="next"
      >
        Next
      </Wizard.Button>
    ),
    showInNav: false,
    stepId: VideoFlowStep.ASPECT_RATIO,
    title: 'Select an aspect ratio',
  };

  return {
    step,
  };
}
